module.exports = {"pathContext":{"slug":"/it/bachelor/","langKey":"it"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/it-bachelor.json
// module id = 1570
// module chunks = 21158907686683